import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import InboxOutlined from '@mui/icons-material/InboxOutlined';

interface Props {
  title?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  dense?: boolean;
}

/** Friendly placeholder shown when a list/section has no data. */
export function EmptyState({ title = 'No records found', description, icon, action, dense }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: dense ? 4 : 7,
        px: 2,
        color: 'text.secondary',
      }}
    >
      <Box sx={{ fontSize: 0, color: 'text.disabled', mb: 1.5, '& svg': { fontSize: 48 } }}>
        {icon ?? <InboxOutlined fontSize="inherit" />}
      </Box>
      <Typography variant="subtitle1" color="text.primary">
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" sx={{ maxWidth: 360, mt: 0.5 }}>
          {description}
        </Typography>
      )}
      {action && <Box mt={2}>{action}</Box>}
    </Box>
  );
}
